import React, { useContext, useMemo } from 'react';

import { Popover } from 'antd';

import { ListContext } from '@contexts/ListContext';

import NwIcon from '@components/Gui/NwIcon';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const ContactDepartments = ({ departments }) => {
    const { cachedList } = useContext(ListContext);

    const DepartmentAndAgencyName = ({ departmentID }) => {
        for (const accGroup of cachedList.accountingGroups.items) {
            for (const nwAg of accGroup.NetworkAgencies) {
                for (const department of nwAg.Departments) {
                    if (department.ID === departmentID) {
                        return (
                            <p>
                                {nwAg.Name} / <strong>{department.Name}</strong>
                            </p>
                        );
                    }
                }
            }
        }
        return null;
    };

    const displayLabels = useMemo(() => {
        return `${departments.length} dept${departments.length > 1 ? 's' : ''}`;

    }, [departments]);

    return (
        <Popover
            title="Departments"
            mouseEnterDelay={0.6}
            content={
                <>
                    {departments.map((dept, index) => (
                        <DepartmentAndAgencyName key={index} departmentID={dept.DepartmentID} />
                    ))}
                </>
            }
        >
            <p>
                <NwIcon icon={byPrefixAndName.fasl['people-group']} />
                &nbsp;&nbsp;{displayLabels}
            </p>
        </Popover>
    );
};

export default ContactDepartments;
